export default __webpack_public_path__ + "static/media/transfert.2941db3b.svg";